// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2joA6","colCheckbox":"styles_colCheckbox__2_Yyn"};